import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { PageLoader } from '@/components/shared/PageLoader';
import { ROUTES } from '@/utils/constants';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user, logout } = useAuthStore();

  const isNonAdmin = !!user && user.role !== 'ADMIN';

  useEffect(() => {
    if (isNonAdmin) logout();
  }, [isNonAdmin, logout]);

  if (isLoading) {
    return <PageLoader label="Loading" />;
  }

  if (!isAuthenticated || isNonAdmin) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
}
